import React, { useState, useEffect } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Button, VStack, HStack, Box, Text, Badge, useToast, Flex, Checkbox,
} from '@chakra-ui/react';
import { FiCopy } from 'react-icons/fi';
import api from '../api';

export default function TemplatePickerModal({ isOpen, onClose, rowGroupId, onCreated }) {
  const [templates, setTemplates] = useState([]);
  const [showDone, setShowDone] = useState(false);
  const [cloning, setCloning] = useState(null);
  const toast = useToast();

  useEffect(() => {
    if (isOpen) fetchTemplates();
  }, [isOpen, showDone]); // eslint-disable-line

  const fetchTemplates = async () => {
    try { const { data } = await api.get(`/projects/templates?show_done=${showDone}`); setTemplates(data); } catch(e) { setTemplates([]); }
  };

  const handleUseTemplate = async (templateId) => {
    setCloning(templateId);
    try {
      const { data } = await api.post(`/projects/${templateId}/clone`, { row_group_id: rowGroupId });
      toast({ title: 'Project created from template', status: 'success', duration: 2000 });
      if (onCreated) onCreated(data);
      onClose();
    } catch(e) { toast({ title: 'Clone failed: ' + (e.response?.data?.error || e.message), status: 'error', duration: 3000 }); }
    finally { setCloning(null); }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" scrollBehavior="inside">
      <ModalOverlay /><ModalContent maxH="80vh">
        <ModalHeader fontSize="md">
          <Flex justify="space-between" align="center" pr={8}>
            <HStack><FiCopy /><Text>Use Template</Text></HStack>
            <Checkbox size="sm" isChecked={showDone} onChange={e => setShowDone(e.target.checked)}>
              <Text fontSize="10px">Show completed</Text>
            </Checkbox>
          </Flex>
        </ModalHeader><ModalCloseButton />
        <ModalBody>
          {templates.length === 0 ? (
            <Text fontSize="sm" color="gray.500" textAlign="center" py={8}>
              {showDone ? 'No templates found.' : 'No active templates. Create a project and mark it as a Workflow Template.'}
            </Text>
          ) : (
            <VStack spacing={2} align="stretch">
              {templates.map(t => (
                <Flex key={t.id} p={3} border="1px" borderColor="gray.200" borderRadius="md"
                  cursor="pointer" _hover={{ bg: 'blue.50', borderColor: 'blue.300' }}
                  onClick={() => handleUseTemplate(t.id)} align="center" justify="space-between"
                  opacity={cloning === t.id ? 0.5 : 1}>
                  <Box>
                    <HStack spacing={2} mb={0.5}>
                      <Text fontSize="13px" fontWeight="700">{t.project_name}</Text>
                      <Badge fontSize="8px" colorScheme="purple">Template</Badge>
                      {!!t.is_done && <Badge fontSize="8px" colorScheme="gray">Done</Badge>}
                    </HStack>
                    {t.job_description && <Text fontSize="10px" color="gray.500" noOfLines={2}>{t.job_description}</Text>}
                    {t.row_group_name && <Text fontSize="9px" color="gray.400" mt={0.5}>{t.row_group_name}</Text>}
                  </Box>
                  <Button size="xs" colorScheme="blue" variant="outline" isLoading={cloning === t.id}
                    onClick={e => { e.stopPropagation(); handleUseTemplate(t.id); }}>Use</Button>
                </Flex>
              ))}
            </VStack>
          )}
        </ModalBody>
        <ModalFooter><Button size="sm" onClick={onClose}>Cancel</Button></ModalFooter>
      </ModalContent>
    </Modal>
  );
}
